export { default } from './MapaComarques';
